
import LazyImage from '@/components/lazy-image';
import { track } from '@/utils/analytics';
import ImageHelper from '@/utils/ImageHelper';
import { Comparator } from '@/ui-kit/enums';
import { StyleSizeType, StyleFontWeightType, StyleColorSchemeType } from '@/ui-kit/styles/enums';
import Typography from '@/ui-kit/components/typography';
import { TypographyType } from '@/ui-kit/components/typography/enums';
import Button from '@/ui-kit/components/button';

/**
   * @component HowItWorksFooterComponent
   *
   * @prop {String} title
   * @prop {String} description
   * @private
   */

export default {
  name: 'HowItWorksFooterComponent',
  components: {
    LazyImage,
    Typography,
    Button,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    image: {
      type: Object,
      required: true,
    },
    link: {
      type: String,
      required: true,
    },
    href: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      TypographyType,
      StyleFontWeightType,
      StyleColorSchemeType,
      StyleSizeType,
    };
  },
  computed: {
    imageRatio() {
      return ImageHelper.constructor.getImageRatio(this.image.dimensions);
    },
    imageSizes() {
      return [
        {
          comparator: Comparator.Less,
          breakpoint: StyleSizeType.XSmall,
          imageSize: 400,
        },
        {
          comparator: Comparator.Less,
          breakpoint: StyleSizeType.Small,
          imageSize: 600,
        },
        {
          comparator: Comparator.Greater,
          breakpoint: StyleSizeType.Small,
          imageSize: 800,
        },
        {
          comparator: Comparator.Greater,
          breakpoint: StyleSizeType.Medium,
          imageSize: 600,
        },
      ];
    },
  },
  methods: {
    /**
      * Tracks the clicking of the bottom footer button
      * (List your home, Start your search or Start listing) in Mixpanel (via Segment).
      *
      * @returns {void}
      * @private
      */

    trackFooterButton() {
      const { path } = this.$route;
      if (path === '/how-it-works/seller') {
        track('How it works_Seller_Sell with Bode button click');
      } else if (path === '/how-it-works/buyer') {
        track('How it works_Buyer_Start your search button click');
      } else {
        track('How it works_Builder_Start listing button click');
      }
    },
  },
};
